/**
 * Returns ID of provided auction/car slug
 *
 * @param slug Slug of an auction or of a car
 */
export const getIdFromSlug = (slug: string) => {
  return Number(slug.split('-').reverse()[0])
}
